import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EnablePublishLayerService } from 'app/services/enable-publish-layer.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class PublishLayerGuard implements CanActivate {
  constructor(
    private enableService: EnablePublishLayerService,
    private toastr: ToastrService) {
    
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const value = this.enableService.getValue();
      if (value == false) {
        this.toastr.warning('No published layer created!');
      }
      return value;
  }
}
